import apiBase from './base'
import apiClient from './client'

export async function getOfficialStoreData (store, id) {
  const url = `${apiBase.getGlueUrl(store)}/v3/official-store/${id}`
  return apiClient.get(url)
}

export default { getOfficialStoreData }
